export const ANIMATE_DURATION = 200;
